import { Form, LoadManager } from '@/components'
import useLicensing from '@/hooks/useLicensing'
import documentNumberMask from '@/lib/masks/documentNumber'
import yup from '@/lib/yupPt'
import { setLicensing } from '@/reducers/licensing'
import protectors from '@/services/api/protectors'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const schema = yup.object().shape({
  revokedReason: yup.string().trim().required().min(10),
})

function Revoke() {
  const { id } = useParams()
  const history = useHistory()
  const [revoking, setRevoking] = useState(false)
  const { state: { licensing }, dispatch } = useLicensing()

  async function revoke(form) {
    try {
      setRevoking(true)
      const { data } = await protectors.revoke(id, form)
      dispatch(setLicensing(data))
      toast.success(`A solicitação de ${licensing?.licensed?.fullName} foi revogada`)
      history.goBack()
    } catch (e) {
      setRevoking(false)
      toast.error(e?.message)
    }
  }

  return (
    <fieldset disabled={revoking}>
      <Form.Formik
        initialValues={{ revokedReason: '' }}
        validationSchema={schema}
        onSubmit={revoke}
        validateOnMount
      >
        {
          ({
            errors, touched, isValid,
          }) => (
            <Form.ValidationForm>
              <div className="modal active" id="modal-id">
                <a type="button" className="modal-overlay" aria-label="Close" onClick={() => history.goBack()} />
                <div className="modal-container">
                  <div className="modal-header">
                    <a
                      type="button"
                      className="btn btn-clear float-right"
                      onClick={() => history.goBack()}
                    />
                    <div className="modal-title h5">Revogar licença do(a) protetor(a)</div>
                  </div>
                  <div className="modal-body">
                    <div className="content text-justify">
                      <LoadManager loading={!licensing}>
                        {
                          licensing?.status === 'approved' ? (
                            <>
                              <p>
                                Deseja revogar a licença do(a) usuário(a)
                                <b className="text-primary"> {licensing?.licensed?.fullName} </b>
                                portador(a) do documento
                                <b className="text-primary"> {documentNumberMask(licensing?.licensed?.documentNumber)} </b>
                                como protetor(a) independente?
                              </p>
                              <p className="text-small">
                                Com isso, este usuário precisará
                                fazer uma nova solicitação caso queira se credenciar
                              </p>
                            </>
                          )
                            : <p>Este credenciamento não pode mais ser revogado</p>
                        }
                        <Form.Group className={`${touched?.revokedReason && errors?.revokedReason ? 'has-error' : ''}`}>
                          <Form.Label htmlFor="label">Descreva o motivo de revogar a licença: <span className="text-error">*</span></Form.Label>
                          <Form.ValidationField
                            name="revokedReason"
                            component="textarea"
                            id="revokedReason"
                            placeholder="Estou revogando a licença porque..."
                          />
                          {
                            touched?.revokedReason && errors?.revokedReason
                              ? <Form.Hint className="text-error">{errors.revokedReason}</Form.Hint> : null
                          }
                        </Form.Group>
                      </LoadManager>
                    </div>
                  </div>
                  {
                    licensing?.status === 'approved' && (
                      <div className="modal-footer">
                        <a
                          className="btn mr-2"
                          disabled={revoking}
                          onClick={() => history.goBack()}
                        >
                          <i className="fas fa-chevron-left" />
                          &nbsp;Voltar
                        </a>
                        <button
                          className={`btn btn-error ${revoking ? 'loading' : ''}`}
                          disabled={!isValid}
                          type="submit"
                        >
                          <i className="fas fa-times" />
                          &nbsp;Revogar
                        </button>
                      </div>
                    )
                  }
                </div>
              </div>
            </Form.ValidationForm>
          )
        }
      </Form.Formik>
    </fieldset>
  )
}

export default Revoke
